import { Button, Result } from "antd";

export default function ConsultErrorState({ error, onRetry, extra }) {
  return (
    <Result
      status="warning"
      title={error?.message || "Không tải được dữ liệu"}
      extra={extra || (onRetry && <Button onClick={onRetry}>Thử lại</Button>)}
    />
  );
}
